<div class="container p-0 m-0 ">
  <div class="d-flex justify-content-between align-items-center p-4">
    <div class="d-flex align-items-center gap-2 title-pill">
      <i class="bi bi-folder-fill folder-icon"></i>
      <h3 class="m-0 page-title">
        @if(data.entityName == 'USER'){ My Documents }
        @else { Files }
      </h3>
    </div>
    <div class="close-icon" mat-dialog-close>
      <i class="bi bi-x"></i>
    </div>
  </div>
  <hr class="p-0 m-0" style="color:#E5E7EB;">

  <div class="table-container p-4  ">
    <mat-table [dataSource]="dataSource" class="custom-table ">
      
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef class="text-center">NAME</mat-header-cell>
        <mat-cell *matCellDef="let element" (click)="viewMediaFile(element)" class="text-center">
          <div class="file-icon-wrapper me-3">
             @if(element.contentType == 'application/pdf'){
                <i class="bi bi-file-pdf-fill pdf-icon"></i>
             } @else {
                <i class="bi bi-image-fill img-icon"></i>
             }
          </div>
          <span class="file-name text-truncate">{{ element.fileName | uppercase }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="docType">
        <mat-header-cell *matHeaderCellDef class="text-center">DOCUMENT TYPE</mat-header-cell>
        <mat-cell *matCellDef="let element" class="text-muted text-center">
          {{ (element.docType ) | uppercase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dateUploaded">
        <mat-header-cell *matHeaderCellDef class="text-center">DATE UPLOADED</mat-header-cell>
        <mat-cell *matCellDef="let element" class="text-center text-muted">
          {{ element.dateUploaded | date:'MMM dd, yyyy' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef class="text-center">DELETE</mat-header-cell>
        <mat-cell *matCellDef="let element" class="text-center">
          <i class="bi bi-trash3-fill delete-icon" 
             [class.disabled]="isInRole(['IS_BUYER_ADMIN','IS_BUYER']) && data.entityName == 'requirement'"
             (click)="deleteMedia(element.id)"></i>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" class="document-row"></mat-row>
    </mat-table>
  </div>
</div>